/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_UnmatchedInputs */

const cs_demands_unmatched = /** @type {(inputs: Demands_UnmatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím nespárováno`)
};

const en_demands_unmatched = /** @type {(inputs: Demands_UnmatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not matched yet`)
};

/**
* | output |
* | --- |
* | "Not matched yet" |
*
* @param {Demands_UnmatchedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_unmatched = /** @type {((inputs?: Demands_UnmatchedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_UnmatchedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_unmatched(inputs)
	return cs_demands_unmatched(inputs)
});